import { REHYDRATE } from "redux-persist";
import {
	ACCOUNT_UPDATE_USER_SUCCESS,
	GET_CURRENT_USER_PERMISSIONS_SUCCESS,
	GET_CURRENT_USER_DICTIONARY_SUCCESS,
	GET_USER_PREFERENCES_SUCCESS,
	UPDATE_USER_PREFERENCES_SUCCESS,
} from "../actions/account-action-types";
import {
	RESET_LOADER,
	SHOW_LOADER,
	HIDE_LOADER
} from "../actions/global-action-types";
import {
	SET_AUTHENTICATION_TOKEN,
	REQUEST_LOGIN_AGAIN,
	CANCEL_REQUEST_LOGIN_AGAIN,
	GETUSER_SUCCESS,
	GETFILTERS_SUCCESS,
	SETSESSIONFILTER,
	SETSESSIONPAGE,
	LOGOUT_SUCCESS,
	SET_SESSION_DOWNLOADS
} from "../actions/user-action-types";

const initialState = {
	token: "",
	tokenExpireDate: "",
	requestLoginAgain: true,
	userInfo: {},
	currentLanguage: "EN",
	userPermissions: {},
	userDictionary: "",
	userPreferences: {
		language: "EN",
		homePage: "exam",
		examListFilter: "",
		examEditorClinicalInfoOpen: false,
		examEditorImagesOpen: true,
		examEditorReportOpen: true,
		examEditorRequestOpen: false,
		examEditorImageRatio: 50,
		patFileDftTab: 0,
	},
	examEditorData: {},
	sessionPage: '',
	sessionFilter: {
		nm: '<#Initial#>',
		t : [],
		i : [],
		m : [],
		es : [],
		sn : '',
		si : '',
		o: true,
		ute : null,
		ura : null,
		uty : null,
		dr : '',
		srd : "Date",
		srt : "ASC",
	},
	sessionDownloads: [],
	filtersList: [],
	pendingTasks: 0,
	examActionsList: [],
};

const session = (state = initialState, action) => {
	switch (action.type) {
		
		/* Account control */

		case SET_AUTHENTICATION_TOKEN:
			console.log('IssueToken:' + JSON.stringify(action.payload));
			return {
				...state,
				token: action.payload.data,
				tokenExpireDate: action.payload.tokenExpireDate,
				requestLoginAgain: false
			};

		case GETUSER_SUCCESS:
			return {
				...state,
				userInfo: action.payload.userInfo,
			};

		case ACCOUNT_UPDATE_USER_SUCCESS: {
			if (action.payload.id === state.userInfo.id) {
				return { ...state, userInfo: { ...state.userInfo, ...action.payload } };
			} else return { ...state };
		}

		case GET_CURRENT_USER_PERMISSIONS_SUCCESS: {
			return {
				...state,
				userPermissions: !action.payload
				? []
				: action.payload.reduce((a, c) => {
					let permissionCode = c.permissionCode;
					return {
						...a,
						[permissionCode]: a[permissionCode]?.length
							? [...a[permissionCode], c.value]
							: [c.value],
					};
				}, {}),
			};
		}
		
		case GET_CURRENT_USER_DICTIONARY_SUCCESS: {
			if (action.payload) {
				return { ...state, userDictionary: action.payload?.split('\r\n') };
			} else {
				return { ...state };
			}
		}
		
		case GET_USER_PREFERENCES_SUCCESS: {
			if (action.payload) {
				return { ...state, userPreferences: action.payload };
			} else {
				return { ...state };
			}
		}

		case UPDATE_USER_PREFERENCES_SUCCESS: {
			return {
				...state,
				userPreferences: { ...state.userPreferences, ...action.payload },
			};
		}

		case GETFILTERS_SUCCESS: {
			return {
				...state,
				filtersList: action.payload?.filtersList,
			};
		}

		case SETSESSIONFILTER: {
			return {
				...state,
				sessionFilter: action.payload?.sessionFilter,
			};
		}

		case SET_SESSION_DOWNLOADS: {
			return {
				...state,
				sessionDownloads: action.payload?.sessionDownloads,
			};
		}

		case SETSESSIONPAGE: {
			return {
				...state,
				sessionPage: action.payload?.sessionPage,
			};
		}

		case LOGOUT_SUCCESS:
			var curState = JSON.parse(JSON.stringify(initialState));
			if(action?.payload?.requestLoginAgain === true || action?.payload?.requestLoginAgain === false){
				curState.requestLoginAgain = action?.payload?.requestLoginAgain;
			}
			return { ...curState };
			
		/* Interface control */

		case REQUEST_LOGIN_AGAIN: {
			return { ...state, requestLoginAgain: true };
		}

		case CANCEL_REQUEST_LOGIN_AGAIN: {
			return { ...state, requestLoginAgain: false };
		}

		case RESET_LOADER: {
			return {
				...state,
				pendingTasks: 0,
			};
		}
		case SHOW_LOADER: {
			return {
				...state,
				pendingTasks: state.pendingTasks >= 0 ? state.pendingTasks + 1 : 1,
			};
		}
		case HIDE_LOADER: {
			return {
				...state,
				pendingTasks: state.pendingTasks >= 0 ? state.pendingTasks - 1 : 0,
			};
		}

		case REHYDRATE: {
			let data = { ...initialState };

			if (action.payload?.session) {
				data = action.payload.session;
			}

			return {
				...data,
			};
		}

		default:
			return state;
	}
};

export { session };
